export const experience = [
  {
    role: "Software Engineering Intern",
    company: "KAI Conversations",
    description:
      "Improved the platform's confidence model by incorporating Japanese conversations. Developed common agenda tags using extractive and generative NLP models. Contributed to manual tagging for the GROW coaching model.",
    testimonial: {
      quote:
        "Your enthusiasm and adaptability during your tenure were truly remarkable. You seamlessly integrated into our fast-paced startup environment and thrived in every aspect. I am particularly impressed with how much you accomplished in such a short period.",
      author: "Milan Panera",
    },
  },
  {
    role: "Software Engineering Intern",
    company: "Tribepad",
    description:
      "Abstracted a core software service using interface design and the Abstract Factory pattern. Worked with legacy PHP and the Laravel framework, handling API calls and processing XML data. Managed the full development cycle from inception through code review.",
    testimonial: {
      quote:
        "From the start of the project he had a positive attitude towards the work and took his time to understand what he was doing. He has a desire to learn and improve and it shows in his interactions.",
      author: "Jon Braud, Senior Software Engineer",
    },
  },
];

export const projects = [
  {
    title: "Gym App",
    description:
      "A mobile application designed to support people struggling with addiction. Built as a university dissertation project.",
    tech: ["Flutter", "Dart"],
    github: "https://github.com/danielxoates/gymapp_flutter",
    link: null,
  },
  {
    title: "LinkMe",
    description:
      "A link-sharing platform that lets users consolidate all their online profiles behind a single URL.",
    tech: ["SvelteKit", "Firebase"],
    github: null,
    link: null
  },
  {
    title: "YouTube Downloader",
    description:
      "Full-stack application for downloading video and audio from YouTube, with a Svelte frontend and Node.js backend.",
    tech: ["Svelte", "Node.js"],
    github: "https://github.com/danielxoates/yt_downloader",
    link: null,
  },
  {
    title: "Circle Packing GA",
    description:
      "A genetic algorithm for the circle packing optimisation problem, with greedy and random algorithm comparisons.",
    tech: ["Java", "Genetic Algorithms"],
    github: "https://github.com/danielxoates/circlePacking",
    link: null,
  },
];

export const skills = {
  languages: ["JavaScript", "Python", "PHP", "Java", "Rust", "C"],
  frameworks: ["React", "Svelte", "SvelteKit", "React Native", "Laravel", "Node.js"],
  tools: ["Git", "Docker", "MySQL", "Firebase", "REST APIs"],
};



// WEBPACK FOOTER //
// ./src/data.js